import {MainApi} from "./MainApi";
import {PageSearchCondition} from "../types/page";

export class BannerApi {
    static baseUrl = `${MainApi.urlPrefix}/user/catalog/banners`;

    static getBanners = (condition: PageSearchCondition) => () =>
        MainApi.api.get(`${BannerApi.baseUrl}${MainApi.toParamStringFromObject(condition)}`);

}